import { ENVIRONMENT } from '@updater-core/lib/environment';
import { createLoggerFunc } from '@updater-core/lib/logger';

export const createLogger = (...args) => {
  return createLoggerFunc(
    ENVIRONMENT.debug?.footerComponent,
    '[DEBUG][FOOTER]',
    'color: #7442f4'
  )(...args);
};

export const logger = createLogger();

export const log = logger.log;
